<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :personal="personal"
          :ingresoEgresoTipo="ingresoEgresoTipo"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Ingresos/Egresos">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="ingresosEgresos" 
              :fields="ingresosEgresosFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaComprobante)="data">
              {{ data.item.fechaComprobante | fecha }}
            </template>
            <template v-slot:cell(total)="data">
              {{ data.item.total | moneda }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <!-- <b-dropdown-item @click.stop="exportPDF(data.item)">
                  <i class="fa fa-file-pdf-o"></i>Emitir Recibo</b-dropdown-item> -->
                <b-dropdown-item @click.stop="borrarItem(data.item)">
                  <i class="fa fa-remove"></i>Anular Ingreso/Egreso</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
// import exportPDFReciboCliente from '../../mixins/export_recibo_cliente_pdf';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'ingresosegresos/getField',
  mutationType: 'ingresosegresos/updateField',
});

export default {
  name: 'IngresosEgresos',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal,
    // exportPDFReciboCliente
  ],
  data: () => {
    return {
      ingresosEgresosFields: [
        { 
          key: 'id',
          label: 'Nro.',
          class: 'text-right'
        },
        { key: 'fechaComprobante' },
        // { key: 'fechaContable' },
        { key: 'personal' },
        { 
          key: 'ingresoEgresoTipo',
          label: 'Tipo' 
        },
        {
          key: 'total',
          class: 'text-right'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'ingresosEgresos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
      'personal',
      'ingresoEgresoTipo'
      // 'cliente',
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    }
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.personal = filtro.personal;
      this.ingresoEgresoTipo = filtro.ingresoEgresoTipo;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('ingresosegresos/getIngresosEgresos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregar () {
      this.$router.push({ name: 'IngresoEgresoABM', 
                          params: { id: 0 }});
    },
    consultar (item) {
      this.$router.push({ name: 'IngresoEgresoData', 
                          params: { id: item.id }});
    },
    borrarItem (item) {
      this.showModalConfirm('¿Desea anular el movimiento seleccionado?', 
            this.borrar.bind(this, item.id), 'Si', null, 'No')
    },
    borrar (ingresoEgresoId) {
      this.$store.dispatch('ingresosegresos/delete', ingresoEgresoId)
        .then(() => this.showModalMsj('El movimiento se anuló con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    // exportPDF(item) {
    //   this.$store.dispatch('empresa/inicializar')
    //     .then(() => {
    //       let empresa = this.$store.getters['empresa/empresa'];
    //       return (empresa);
    //     })
    //     .then((empresa) => {
    //       this.$store.dispatch('cobro/getDatos', item.id)
    //         .then(() => {
    //           this.exportPDFReciboCliente(this.$store.getters['cobro/cobroDatosRpt'], empresa);
    //         })
    //     })
    //     .catch( error => {
    //       this.modalOkAction = null;
    //       this.modalHiddenAction = null;
    //       this.modalMensaje = error;
    //       this.modalMsj = true;
    //     })
    // },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
